import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { reviewCardHref } from "./reviewCardLink";

// A2-637 Owner D (card map D-4, operator's Step 4 check 2026-11-02): 6,356
// credit notes waited for a channel on Step 4, in no box, and no return page
// said so. The calculation's rows on no return yet, by the card that places
// them (api/_held_rows.attach_unplaced_rows). Shown on every country's page:
// such a row has no country until it is answered.
export function UnplacedRowsNote({ data }) {
  const { t } = useTranslation();
  const { calcId } = useParams();
  if (!data || !data.rows) return null;
  return (
    <div data-testid="unplaced-rows-note"
         className="text-xs bg-slate-50 dark:bg-slate-900/40 border border-slate-300 dark:border-slate-700 rounded-lg p-3 mb-4 text-slate-800 dark:text-slate-100">
      <div className="font-semibold">
        {t("ui.country_return.unplaced.title", { count: data.rows,
          defaultValue: `${data.rows} rows of this calculation are on no return yet` })}
      </div>
      <div className="mt-0.5 opacity-90">
        {t("ui.country_return.unplaced.why", {
          defaultValue: "Once answered on Step 4 and re-run, each goes to its country's return; this page may change then." })}
      </div>
      <ul className="list-disc ml-5 mt-1">
        {(data.parts || []).map((p) => (
          <li key={p.card} data-testid={`unplaced-rows-${p.card}`}>
            {p.card ? (
              <Link to={reviewCardHref(p.card, calcId)} className="underline font-semibold">
                {t(`flag_titles.${p.card}`, { defaultValue: t("ui.country_return.held.card_default", { defaultValue: "its card" }) })}
              </Link>
            ) : t("ui.country_return.unplaced.no_card", { defaultValue: "Not yet classified — check the file's rows" })}
            {" "}
            {t("ui.country_return.unplaced.rows", { count: p.rows, defaultValue: `(${p.rows} rows)` })}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default UnplacedRowsNote;
